"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Action = exports.Status2 = exports.MarketingChannel = exports.BillingPeriod = exports.AuthorizedUserType = exports.Currency = exports.SubscriptionAction = exports.Channel = exports.BillingProviderType = exports.PurchasePaymentMethod = exports.Period = exports.Status = void 0;
var Status;
(function (Status) {
    Status["OPEN"] = "OPEN";
    Status["FUNDED"] = "FUNDED";
    Status["FULLY_FUNDED"] = "FULLY_FUNDED";
})(Status = exports.Status || (exports.Status = {}));
var Period;
(function (Period) {
    Period["DAY"] = "DAY";
    Period["WEEK"] = "WEEK";
    Period["MONTH"] = "MONTH";
    Period["QUARTER"] = "QUARTER";
    Period["BIANNUAL"] = "BIANNUAL";
    Period["ANNUAL"] = "ANNUAL";
    Period["PAY_PERIOD"] = "PAY_PERIOD";
})(Period = exports.Period || (exports.Period = {}));
var PurchasePaymentMethod;
(function (PurchasePaymentMethod) {
    PurchasePaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PurchasePaymentMethod["BANK_DRAFT"] = "BANK_DRAFT";
    PurchasePaymentMethod["PREMIUM_BILLING"] = "PREMIUM_BILLING";
    PurchasePaymentMethod["CHECK"] = "CHECK";
})(PurchasePaymentMethod = exports.PurchasePaymentMethod || (exports.PurchasePaymentMethod = {}));
var BillingProviderType;
(function (BillingProviderType) {
    BillingProviderType["PSX"] = "PSX";
    BillingProviderType["SYSTEM_I"] = "SYSTEM I";
})(BillingProviderType = exports.BillingProviderType || (exports.BillingProviderType = {}));
var Channel;
(function (Channel) {
    Channel["GroupSites"] = "GroupSites";
    Channel["Corp"] = "Corp";
    Channel["Hubsites"] = "Hubsites";
    Channel["LaunchByLS"] = "LaunchByLS";
    Channel["BuyNow"] = "BuyNow";
})(Channel = exports.Channel || (exports.Channel = {}));
var SubscriptionAction;
(function (SubscriptionAction) {
    SubscriptionAction["CREATE"] = "CREATE";
    SubscriptionAction["UPDATE"] = "UPDATE";
})(SubscriptionAction = exports.SubscriptionAction || (exports.SubscriptionAction = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
var AuthorizedUserType;
(function (AuthorizedUserType) {
    AuthorizedUserType["SPOUSE"] = "SPOUSE";
    AuthorizedUserType["DEPENDENT"] = "DEPENDENT";
})(AuthorizedUserType = exports.AuthorizedUserType || (exports.AuthorizedUserType = {}));
var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(BillingPeriod = exports.BillingPeriod || (exports.BillingPeriod = {}));
var MarketingChannel;
(function (MarketingChannel) {
    MarketingChannel["GROUPSITES"] = "GROUPSITES";
    MarketingChannel["CORP"] = "CORP";
    MarketingChannel["HUBSITES"] = "HUBSITES";
    MarketingChannel["LAUNCH_BY_LS"] = "LAUNCH_BY_LS";
    MarketingChannel["BUYNOW"] = "BUYNOW";
})(MarketingChannel = exports.MarketingChannel || (exports.MarketingChannel = {}));
var Status2;
(function (Status2) {
    Status2["OPEN"] = "OPEN";
    Status2["FUNDED"] = "FUNDED";
    Status2["PROVISIONED"] = "PROVISIONED";
    Status2["PAYMENT_FAILED"] = "PAYMENT_FAILED";
})(Status2 = exports.Status2 || (exports.Status2 = {}));
var Action;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED"] = "UPDATED";
    Action["DELETED"] = "DELETED";
    Action["OWNER_ASSIGNED"] = "OWNER_ASSIGNED";
    Action["STATUS_CHANGED"] = "STATUS_CHANGED";
    Action["ENTITLEMENTS_CREATED"] = "ENTITLEMENTS_CREATED";
    Action["SUBSCRIPTIONS_CREATED"] = "SUBSCRIPTIONS_CREATED";
})(Action = exports.Action || (exports.Action = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://purchases.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Purchases
 * @version v1
 * @baseUrl https://purchases.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags OrdersJournal
             * @name OrdersJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/orders/journal
             * @secure
             */
            ordersJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersCreateOrder2
             * @request POST:/v1/orders
             * @secure
             */
            anonymousOrdersCreateOrder2: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersGetOrderAnonymous2
             * @request GET:/v1/orders/{orderId}
             * @secure
             */
            anonymousOrdersGetOrderAnonymous2: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersModifyOffers2
             * @request PUT:/v1/orders/{orderId}/offers
             * @secure
             */
            anonymousOrdersModifyOffers2: (orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}/offers`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersUpdateAuthorizedUsers
             * @request PUT:/v1/orders/{orderId}/authorizedUsers
             * @secure
             */
            anonymousOrdersUpdateAuthorizedUsers: (orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}/authorizedUsers`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Non anonymous orders must be created within the context of a user identity
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersCreateOrder2
             * @summary User JWT Only
             * @request POST:/v1/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersCreateOrder2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrders2
             * @request GET:/v1/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersGetOrders2: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrderWithIdentity2
             * @request GET:/v1/identities/{identityId}/orders/{orderId}
             * @secure
             */
            authorizedOrdersGetOrderWithIdentity2: (identityId, orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersAssignOwner2
             * @summary Machine JWT Only
             * @request POST:/v1/orders/{orderId}/assignOwner
             * @secure
             */
            authorizedOrdersAssignOwner2: (orderId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}/assignOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Purchasing must be done by a person
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersPurchaseOrder2
             * @summary User JWT Only
             * @request POST:/v1/identities/{identityId}/orders/{orderId}/purchase
             * @secure
             */
            authorizedOrdersPurchaseOrder2: (identityId, orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders/${orderId}/purchase`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.orders = {
            /**
             * @description The journal is for internal use only
             *
             * @tags OrdersJournal
             * @name OrdersJournal
             * @summary Machine JWT Only
             * @request GET:/orders/journal
             * @secure
             */
            ordersJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/orders/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OrdersJournal
             * @name OrdersJournalGetJournalMaxClock
             * @request GET:/orders/journal/maxClock
             * @secure
             */
            ordersJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/orders/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersCreateOrder
             * @request POST:/v2/orders
             * @secure
             */
            anonymousOrdersCreateOrder: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersGetOrderAnonymous
             * @request GET:/v2/orders/{orderId}
             * @secure
             */
            anonymousOrdersGetOrderAnonymous: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersModifyOffers
             * @request PUT:/v2/orders/{orderId}/offers
             * @secure
             */
            anonymousOrdersModifyOffers: (orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/offers`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Non anonymous orders must be created within the context of a user identity
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersCreateOrder
             * @summary User JWT Only
             * @request POST:/v2/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersCreateOrder: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrders
             * @request GET:/v2/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersGetOrders: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrderWithIdentity
             * @request GET:/v2/identities/{identityId}/orders/{orderId}
             * @secure
             */
            authorizedOrdersGetOrderWithIdentity: (identityId, orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersAssignOwner
             * @summary Machine JWT Only
             * @request POST:/v2/orders/{orderId}/assignOwner
             * @secure
             */
            authorizedOrdersAssignOwner: (orderId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/assignOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersProvisionOrder
             * @summary Machine JWT Only
             * @request POST:/v2/orders/{orderId}/provision
             * @secure
             */
            authorizedOrdersProvisionOrder: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/provision`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersPurchaseOrder
             * @request POST:/v2/identities/{identityId}/orders/{orderId}/purchase
             * @secure
             */
            authorizedOrdersPurchaseOrder: (identityId, orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders/${orderId}/purchase`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupAuthorizedOrders
             * @name GroupAuthorizedOrdersCreateOrder
             * @request POST:/v2/groups/{groupId}/identities/{identityId}/orders
             * @secure
             */
            groupAuthorizedOrdersCreateOrder: (identityId, groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/groups/${groupId}/identities/${identityId}/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupAuthorizedOrders
             * @name GroupAuthorizedOrdersGetOrders
             * @request GET:/v2/groups/{groupId}/identities/{identityId}/orders
             * @secure
             */
            groupAuthorizedOrdersGetOrders: (identityId, groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/groups/${groupId}/identities/${identityId}/orders`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupAuthorizedOrders
             * @name GroupAuthorizedOrdersGetOrderWithIdentity
             * @request GET:/v2/groups/{groupId}/identities/{identityId}/orders/{orderId}
             * @secure
             */
            groupAuthorizedOrdersGetOrderWithIdentity: (identityId, orderId, groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/groups/${groupId}/identities/${identityId}/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupAuthorizedOrders
             * @name GroupAuthorizedOrdersPurchaseOrder
             * @request POST:/v2/groups/{groupId}/identities/{identityId}/orders/{orderId}/purchase
             * @secure
             */
            groupAuthorizedOrdersPurchaseOrder: (identityId, orderId, groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/groups/${groupId}/identities/${identityId}/orders/${orderId}/purchase`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=purchases.js.map